<template>
  <div class="t-deal">
    <UBadge color="error" size="lg" class="mb-2">{{
      t('components.deal.percentage', percentage)
    }}</UBadge>

    <TText classes="mt-0 mb-1" variant="semibold" clamp="clamp1">{{
      title
    }}</TText>

    <TText size="sm" classes="mt-0 mb-1">
      {{ t('components.deal.nights', nights) }}
      {{
        t('components.deal.dates', {
          dateIn: dateInDisplay,
          dateOut: dateOutDisplay,
        })
      }}
    </TText>

    <TText size="sm" classes="mt-0 mb-1">
      {{ t('components.deal.people', people) }}
      {{
        t('components.deal.pricePersonNight', {
          pricePersonNight: pricePersonNight,
        })
      }}
    </TText>

    <TText size="sm" classes="mt-0 mb-4">
      <strong>{{ t('components.deal.total', { total: total }) }}</strong>
      {{ t('components.deal.totalOld', { totalOld: totalOld }) }}
    </TText>

    <UAccordion v-model="open" :items="items">
      <template #body>
        <TText size="sm" classes="mt-0 mb-4">
          <span v-html="description" />

          <br />

          <strong>{{ t('components.deal.whatIncludes') }}</strong>

          <span v-html="whatIncludes" />
        </TText>

        <UButton
          color="neutral"
          variant="solid"
          :label="t('components.deal.button')"
          rel="nofollow"
          :to="gotoPrices"
          external
        />
      </template>
    </UAccordion>
  </div>
</template>

<script setup lang="ts">
import type { AccordionItem } from '@nuxt/ui'

export interface Props {
  title: string
  description: string

  percentage: number
  whatIncludes: string

  total: string
  totalOld: string

  dateIn: string
  dateOut: string

  nights: number
  people: number

  pricePersonNight: string

  slug: string
  province: string
  id: string
  rentUnitId: string
}

const props = defineProps<Props>()

// Convert dates from URL format (dd-MM-yyyy) to display format (dd/MM/yyyy)
const dateInDisplay = computed(() => toRuralityDate().displayDate(props.dateIn))
const dateOutDisplay = computed(() =>
  toRuralityDate().displayDate(props.dateOut),
)

const open = ref('')

const getLabel = computed(() => {
  if (open.value === '0') {
    return t('components.deal.open')
  } else {
    return t('components.deal.close')
  }
})

const items: AccordionItem[] = reactive([
  {
    label: getLabel,
  },
])

const gotoPrices = routes().prices({
  slug: props.slug,
  province: props.province,
  dateIn: props.dateIn,
  dateOut: props.dateOut,
  capacity: String(props.people),
  rent_unit: props.rentUnitId,
})
</script>
